{
  "it": {
    "todo_group": {
      "actions": {
        "create": "Attività",
        "update": "Modifica attività"
      },
      "attributes": {
        "category": "Categoria",
        "created_at": "Creato",
        "description": "Descrizione",
        "title": "Titolo",
        "todos_count": "Attività",
        "units": "Unità"
      },
      "categories": {
        "confirmation": "Conferma",
        "upload": "Caricamento"
      },
      "labels": {
        "no_groups": "Ancora nessuna attività per questo progetto.",
        "required": "Questo campo è obbligatorio"
      },
      "toasts": {
        "create": "Attività creata",
        "delete": "Attività eliminata",
        "update": "Attività aggiornata"
      }
    }
  }
}
